import {
  Box,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import { Form, useNotify } from "react-admin";
import { useParams } from "react-router-dom";
import sendRequest from "../dataProvider/sendRequest";
import HMLogo from "../layout/HMLogo";
import DownloadFieldByPdfLink from "../unit/DownloadFieldByPdfLink";
import UploadImage from "../unit/UploadImage";
const PageHeader = () => (
  <Box
    sx={{
      padding: 2,
      textAlign: "left",
      borderBottom: "7px solid #04983F",
      display: "flex",
      alignItems: "center",
      color: "grey",
    }}
  >
    Powered by <HMLogo />
  </Box>
);
const PageFooter = () => (
  <Box
    sx={{
      padding: 2,
      textAlign: "center",
      bottom: 0,
      left: 0,
      right: 0,
    }}
  >
    <Typography variant="body2" sx={{ color: "grey" }}>
      Copyright Happy Mango {new Date().getFullYear()}
    </Typography>
  </Box>
);
type FormValues = {
  email: string;
};

const PurchaseInfo2 = ({ ...props }) => {
  const PurchasedetailData = props?.PurchasedetailData || {};
  const userPurchaseData = props?.userPurchaseData || {};
  const userProductDataNum = props?.userProductDataNum || 1;

  if (!PurchasedetailData || Object.keys(PurchasedetailData).length === 0) {
    return null;
  }

  const PurchasedetailDataFormat: Record<string, string> = {
    product_name: "textFormat",
    product_color: "textFormat",
    product_size: "textFormat",
    product_model: "textFormat",
    list_price: "moneyFormat",
    total_price: "moneyFormat",
    min_payment: "moneyFormat",
    insurance_docs: "fileFormat",
    purchase_invoice: "fileFormat",
  };

  const Product = PurchasedetailData.Product || [];
  const ProductUserData = userPurchaseData?.Product || [];
  const ProductUserDataOther = userPurchaseData?.Other || {};

  return (
    <Box sx={{ padding: 2, width: "100%", height: "100%", margin: "auto" }}>
      <Box sx={{ maxWidth: "800px", margin: "auto" }}>
        <Table>
          <TableBody>
            {Product && userProductDataNum > 0 && (
              <>
                <TableRow key={Math.random().toString(36).substring(2, 15)}>
                  <TableCell
                    className="application_title"
                    style={{
                      width: "150px",
                      textAlign: "left",
                      paddingLeft: "20px",
                    }}
                  >
                    Product #
                  </TableCell>
                  {Array.from({ length: userProductDataNum }).map((_, pnum) => (
                    <TableCell key={pnum} style={{ textAlign: "center" }}>
                      Product {pnum + 1}
                    </TableCell>
                  ))}
                </TableRow>
                {Object.entries(Product).map(([k, v]) => {
                  if (
                    PurchasedetailDataFormat[k] === "fileFormat" ||
                    k == "total_price"
                  )
                    return null;
                  return (
                    <TableRow key={Math.random().toString(36).substring(2, 15)}>
                      <TableCell
                        className="application_title"
                        style={{
                          width: "150px",
                          textAlign: "left",
                          paddingLeft: "20px",
                        }}
                      >
                        {v}
                      </TableCell>
                      {Array.from({ length: userProductDataNum }).map(
                        (_, pnum) => (
                          <TableCell key={`${k}_${pnum}`}>
                            <TextField
                              type="text"
                              variant="outlined"
                              className={`${PurchasedetailDataFormat[k]} product_num_${pnum} ${k}`}
                              id={`${k}_${pnum}`}
                              name={`${k}_${pnum}`}
                              value={ProductUserData?.[1]?.[k] || ""}
                              fullWidth
                              InputProps={{
                                readOnly: true,
                                style: {
                                  backgroundColor:
                                    PurchasedetailDataFormat[k] ===
                                    "moneyFormat"
                                      ? "#ffffdc"
                                      : "#eee",
                                },
                              }}
                            />
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  );
                })}
              </>
            )}

            <TableRow>
              <TableCell
                className="application_title"
                style={{
                  width: "55%",
                  textAlign: "right",
                  paddingRight: "10px",
                }}
              >
                Total Price
              </TableCell>
              <TableCell>
                <TextField
                  type="text"
                  variant="outlined"
                  className="price_text"
                  id="product_total_price"
                  value={ProductUserDataOther.product_total_price || ""}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                    style: { backgroundColor: "#ffffdc", textAlign: "right" },
                  }}
                  sx={{ "& .MuiOutlinedInput-input": { textAlign: "right" } }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className="application_title"
                style={{
                  width: "55%",
                  textAlign: "right",
                  paddingRight: "10px",
                }}
              >
                Loan Amount
              </TableCell>
              <TableCell>
                <TextField
                  type="text"
                  variant="outlined"
                  className="price_text"
                  id="loan_amount"
                  value={props?.loan_amount || ""}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                    style: { backgroundColor: "#ddd", textAlign: "right" },
                  }}
                  sx={{ "& .MuiOutlinedInput-input": { textAlign: "right" } }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className="application_title"
                style={{
                  width: "55%",
                  textAlign: "right",
                  paddingRight: "10px",
                }}
              >
                Borrower Pay
              </TableCell>
              <TableCell>
                <TextField
                  type="text"
                  variant="outlined"
                  className="price_text"
                  id="borrower_payment_amount"
                  value={ProductUserDataOther.borrower_payment_amount || ""}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                    style: { backgroundColor: "#ddd", textAlign: "right" },
                  }}
                  sx={{ "& .MuiOutlinedInput-input": { textAlign: "right" } }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

const PurchaseBottomData = ({ ...props }) => {
  const vendorBottomStandardAttrs = props?.vendorBottomStandardAttrs || [];
  const uploadedFiles = props?.uploadedFiles || [];
  if (!vendorBottomStandardAttrs || vendorBottomStandardAttrs.length === 0) {
    return null;
  }
  return (
    <Box sx={{ padding: 2, width: "100%", height: "100%", margin: "auto" }}>
      <Box sx={{ maxWidth: "800px", margin: "auto" }}>
        {vendorBottomStandardAttrs.map((item, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography variant="body1" gutterBottom>
              {item.sCaption}
            </Typography>
            {item.sHtmlElement === "file" && (
              <>
                {uploadedFiles && (
                  <>
                    {uploadedFiles?.map((index, item) => {
                      <Typography>{item}</Typography>;
                    })}
                  </>
                )}
                <UploadImage
                  uploadName="vendorFile"
                  uploadApi={"vendors/actions/uploadFiles/" + props?.appId}
                  onSuccess={(filelist: any) => {
                    props?.setUploadFiles(filelist);
                  }}
                />
              </>
            )}
            {item.sHtmlElement === "date" && (
              <TextField
                type="date"
                variant="outlined"
                name={item.sField}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            )}
            {(item.sHtmlElement === "text" ||
              item.sHtmlElement === "amount") && (
              <TextField
                type="text"
                variant="outlined"
                name={item.sField}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            )}
            {(item.sHtmlElement === "textfield" ||
              item.sHtmlElement === "textarea") && (
              <TextField
                multiline
                variant="outlined"
                rows={4}
                name={item.sField}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            )}
            {item.sHtmlElement === "checkbox" && (
              <Box>
                <input type="checkbox" /> Yes &nbsp;&nbsp;&nbsp;&nbsp;
                <input type="checkbox" /> No
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
const PurchaseCustomData = ({ ...props }) => {
  const vendorBBSettingrec = props.vendorBBSettingrec || [];
  if (!vendorBBSettingrec || vendorBBSettingrec.length === 0) {
    return null;
  }
  return (
    <Box sx={{ padding: 2, width: "100%", height: "100%", margin: "auto" }}>
      <Box sx={{ maxWidth: "800px", margin: "auto" }}>
        {vendorBBSettingrec.map((item, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography variant="body1" gutterBottom>
              {item.sCaption}
            </Typography>
            {item.sHtmlElement === "file" && (
              <TextField
                type="file"
                variant="outlined"
                name={item.sField}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            )}
            {item.sHtmlElement === "date" && (
              <TextField
                type="date"
                variant="outlined"
                name={item.sField}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            )}
            {(item.sHtmlElement === "text" ||
              item.sHtmlElement === "amount") && (
              <TextField
                type="text"
                variant="outlined"
                name={item.sField}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            )}
            {(item.sHtmlElement === "textfield" ||
              item.sHtmlElement === "textarea") && (
              <TextField
                multiline
                variant="outlined"
                rows={4}
                name={item.sField}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            )}
            {item.sHtmlElement === "checkbox" && (
              <Box>
                {item.sFieldOptions &&
                  item.sFieldOptions.split(",").map((option, idx) => (
                    <Box key={idx}>
                      <input type="checkbox" /> {option.trim()}
                    </Box>
                  ))}
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
const VendorVerifyPage = () => {
  const params = useParams();
  const token = params.token;
  const [loading, setLoading] = React.useState(false);
  const [verificationOption, setVerificationOption] = React.useState("");
  const [bankerInfo, setBankerInfo] = React.useState({});
  const [appId, setAppId] = React.useState(0);
  // const [pdflink, setPdfLink] = React.useState("filesys/vendorverifyzip/27867");
  const [pdflink, setPdfLink] = React.useState("");
  const [topData, setTopData] = React.useState<
    Record<string, { caption: string; field: string; value: string }>
  >({});
  const [errorMessage, setErrorMessage] = React.useState("");
  const [uploadedFiles, setUploadedFiles] = React.useState([]);
  const setUploadFiles = (files: any) => {
    setUploadedFiles(files);
  };
  const notify = useNotify();
  const handleSubmit = async (auth: FormValues) => {
    if (!uploadedFiles) {
      setErrorMessage("Please upload at least one file.");
      return;
    }
    setLoading(true);
    const reqUrl = "verify-vendor";
    const formJson = {
      token: token,
      status: "Verified",
      ...auth,
    };
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: formJson,
    });
    if (response && (response.status == "200" || response.code == "200")) {
      setErrorMessage("");
      setPdfLink(response?.data?.pdflink);
      setLoading(false);
    } else {
      if (response && response.message) {
        setErrorMessage(response.message);
      } else {
        setErrorMessage("Data save failed");
      }

      setLoading(false);
    }
  };

  React.useEffect(() => {
    const fetchBankerInfo = async () => {
      if (token) {
        const reqUrl = "vendor/actions/getinfo";
        const response = await sendRequest(reqUrl, {
          id: 0,
          data: { token },
        });
        if (response && response.code == "200") {
          setBankerInfo(response.data);
          setAppId(response.data.appId || 0);

          if (response.data?.vendorTopStandardAttrs) {
            const standVendorData = response.data.standVendorData || {};
            let topDatatemp: Record<
              string,
              { caption: string; field: string; value: string }
            > = {};
            response.data.vendorTopStandardAttrs.forEach((item: any) => {
              topDatatemp[item.sField] = {
                caption: item.sCaption,
                field: item.sField,
                value: standVendorData[item.sField] || "",
              };
            });

            topDatatemp["vendor_name"] = {
              caption: "Vendor Name",
              field: "vendor_name",
              value: response.data.vendor_name || "",
            };
            setTopData(topDatatemp);
          }
          setErrorMessage("");
        } else {
          setErrorMessage(response?.message || "Failed to fetch banker info");
        }
      }
    };
    fetchBankerInfo();
  }, [token]);

  if (!bankerInfo) {
    return (
      <Typography
        sx={{ textAlign: "center", m: 5, fontSize: "1.2rem", color: "red" }}
      >
        Loading information...
      </Typography>
    );
  }
  return (
    <>
      <PageHeader />
      {errorMessage == "" ? (
        <>
          {pdflink && (
            <>
              <Box
                sx={{
                  padding: 2,
                  textAlign: "center",
                  minHeight: "500px",
                }}
              >
                <Typography variant="h4" gutterBottom>
                  Information saved!
                </Typography>

                <Typography variant="body1" gutterBottom>
                  Click{" "}
                  <DownloadFieldByPdfLink
                    linktoken={pdflink}
                    filename={"Vendor_Verification_Form.pdf"}
                    label="Download Completed Form"
                    sx={{ fontSize: "1.2rem", verticalAlign: "middle" }}
                  />{" "}
                  to download the completed form.
                </Typography>
              </Box>
            </>
          )}
          {!pdflink && (
            <Box
              sx={{ padding: 2, width: "100%", height: "100%", margin: "auto" }}
            >
              <Box sx={{ maxWidth: "800px", margin: "auto" }}>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item xs={12} sm={3} md={3}>
                    {bankerInfo?.banklogo && (
                      <img
                        src={
                          bankerInfo?.banklogo ||
                          "/images/happymango-logo-b.png"
                        }
                        style={{ maxWidth: "90%" }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={9} md={9} sx={{ textAlign: "right" }}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      sx={{ fontSize: "26px", color: "#c6c6c6" }}
                    >
                      {bankerInfo?.productName || "Happy Mango Bank"}
                    </Typography>
                    <Typography
                      variant="body1"
                      gutterBottom
                      sx={{ mt: 2, color: "#76899E", fontSize: "22px" }}
                    >
                      Completion of Transaction by Vendor
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sx={{ borderBottom: "4px solid #c6c6c6" }}>
                    <Table>
                      <TableBody>
                        {topData &&
                          Object.keys(topData).map((key) => (
                            <>
                              <TableRow key={key}>
                                <TableCell>{topData[key].caption}</TableCell>
                                <TableCell
                                  sx={{
                                    color: "#76899E",
                                  }}
                                >
                                  {topData[key].value || ""}
                                </TableCell>
                              </TableRow>
                            </>
                          ))}
                      </TableBody>
                    </Table>
                  </Grid>
                  <Grid item xs={12}>
                    <PurchaseInfo2
                      PurchasedetailData={bankerInfo?.PurchasedetailData}
                      userPurchaseData={bankerInfo?.userPurchaseData || {}}
                      userProductDataNum={bankerInfo?.userProductDataNum || 1}
                      loan_amount={bankerInfo?.loan_amount || ""}
                    />
                  </Grid>
                  <Form onSubmit={handleSubmit} noValidate>
                    <Grid item xs={12}>
                      <PurchaseCustomData
                        vendorBBSettingrec={
                          bankerInfo?.vendorBBSettingrec || []
                        }
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <PurchaseBottomData
                        vendorBottomStandardAttrs={
                          bankerInfo?.vendorBottomStandardAttrs || []
                        }
                        setUploadFiles={setUploadFiles}
                        uploadedFiles={uploadedFiles}
                        loannum={bankerInfo?.loannum || ""}
                        appId={appId}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1" sx={{ mt: 2 }}>
                        If you have any questions about how to fill out this
                        form, please contact
                        {
                          bankerInfo?.vendorContactRec?.sVendorContactEmail
                        } at {bankerInfo?.vendorContactRec?.sVendorPhone} or
                        email{" "}
                        <a
                          href={`mailto:${bankerInfo?.vendorContactRec?.sVendorContactEmail}`}
                          style={{ color: "#00ccb1" }}
                        >
                          {bankerInfo?.vendorContactRec?.sVendorContactEmail}
                        </a>
                        .
                      </Typography>
                    </Grid>
                    {bankerInfo && (
                      <Grid item xs={12} sx={{ mt: 2, textAlign: "right" }}>
                        <Button
                          variant="contained"
                          type="submit"
                          color="primary"
                          disabled={loading}
                          sx={{
                            backgroundColor: "#00ccb1",
                            "&:hover": {
                              backgroundColor: "#00b39b",
                            },
                          }}
                        >
                          {loading && (
                            <CircularProgress size={25} thickness={2} />
                          )}
                          Purchase Completed
                        </Button>
                      </Grid>
                    )}
                  </Form>
                </Grid>
              </Box>
            </Box>
          )}
        </>
      ) : (
        <Typography
          sx={{ textAlign: "center", m: 5, fontSize: "1.2rem", color: "red" }}
        >
          {errorMessage}
        </Typography>
      )}
      <PageFooter />
    </>
  );
};
export default VendorVerifyPage;
